module.exports = __webpack_public_path__ + "img/moped-rodeo.8724b73b.png";